export const getters = {
  systemOilsreceiving: state => state.oils,
  oilsitemsRows: state => state.grn_item_orders,
  Oil: state => state .systemOilreceiving
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/oils/getters.js